// Render Prop

import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { EmployerApi } from "../../../util/api/EmployerApi";
import SimpleField from "../../forms/SimpleField";

import Employer from "../../../store/wrappers/Employer";

import BackButton from "../../widgets/BackButton";
import DatePickerField from '../../forms/DatePickerField';
import Holiday from '../../../store/wrappers/Holiday';



export class HolidayForm extends Component {
    static displayName = HolidayForm.name;

    constructor(props) {
        super(props);

        //Assume we're creating a new holiday unless the user provided a valid id as a url argument
        let holiday = new Holiday();
        let displayMode = "new";

        if (this.props.match.params.id) {
            holiday = this.props.store.holidays.getById(this.props.match.params.id);
            displayMode = "edit";
        }

        this.state = {
            isSubmitting: false,
            holiday: holiday,
            mode: displayMode
        };

        if (displayMode == "new") {
            this.props.store.updateBanner("Add New");
        }
        else {
            this.props.store.updateBanner("Update Date Notice", holiday.holidayName);
        }
    }


    setInitialValues() {
        let holiday = this.state.holiday;
        if (!holiday) {
            holiday = new Holiday()
        }

        return {
            id: holiday.id,
            holidayName: holiday.holidayName,
            note: holiday.note,
            holidayBegin: holiday.holidayBegin,
            holidayEnd: holiday.holidayEnd,
        }
    }

    async handleSubmission(values, setSubmitting, resetForm) {
        this.setState({ setSubmitting: true });

        if (values.id == "" && this.state.holiday.id) {
            values.id = this.state.holiday.id;
        }

        let holiday = new Holiday(values, true);

        holiday = await holiday.save(this.props.store);
        await this.props.store.getFromApi();

        //If there are now errors and the user is inputting holidays. 
        if (this.state.mode == "new" && (holiday.errors == null || holiday.errors.length == 0)) {
            console.log("added holiday")
            resetForm();
            this.setState({ setSubmitting: false });
        }
        else if (this.state.mode == "edit" && (holiday.errors == null || holiday.errors.length == 0)) {
            console.log("updated holiday")
            this.setState({
                holiday: holiday,
                setSubmitting: false,
                mode: "edit"
            });
        }
    }

    validate(values) {
        const errors = {};
        
        return errors;
    }

    render() {
        return (
            <div>
                {this.introText()}
                <div className="row">
                    <div className="col-12 col-md-6">
                        {this.form()}
                    </div>
                </div>
            </div>
        )
    }

    introText() {
        if (this.state.mode == "new") {
            return (
                <React.Fragment>
                    <h1 className="h3">New Date Notice</h1>
                </React.Fragment>
            )
        }
        return (undefined)
    }

    form() {
        return (
            (this.state.mode === "new" || this.state.holiday ? (
                <Formik
                    initialValues={this.setInitialValues()}
                    validate={values => this.validate(values)}
                    onSubmit={(values, { setSubmitting, resetForm }) => this.handleSubmission(values, setSubmitting, resetForm)}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Field name="id" className="form-control" type="hidden" name="id"/>

                            <SimpleField type="text" name="holidayName" label="Display Name" />
                            <SimpleField type="textarea" name="note" label="Note to display (optional)" />
                            <DatePickerField format="MM/dd/yyyy" name="holidayBegin" label="Start Date" />
                            <DatePickerField format="MM/dd/yyyy" name="holidayEnd" label="End Date (optional)" />



                            <div className="staffFormSubmitButtons">
                                {this.state.holiday &&
                                    <BackButton className="btn btn-secondary mt-2 mr-2" innerText="Cancel" />
                                }
                                <button className="btn btn-primary mt-2" type="submit" disabled={isSubmitting}>
                                    Submit
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            ) :
                (
                    <div>
                        <h3>Could not find holiday.</h3>
                    </div>
                )
            )
        );
    }
}
